import { AccessMenuItem, IAccessProfileMenu } from "../interfaces/users/access.interface";
import {
  MOCKED_MENU_BOTTOM_ITEMS,
  MOCKED_MENU_TOP_ITEMS,
  PANEL_MENU_ITEMS
} from "./panel.constants";

export function getMenuItems() {
  const permissions = getPermissions();
  if (!permissions) return [];

  const permissionMap = buildPermissionMap(permissions);

  const filteredMenu = PANEL_MENU_ITEMS
    .map(item => mapMenuItem(item, permissionMap))
    .filter((item): item is NonNullable<typeof item> => !!item);

  return [
    ...MOCKED_MENU_TOP_ITEMS,
    ...filteredMenu,
    ...MOCKED_MENU_BOTTOM_ITEMS
  ];
}

function getPermissions() {
  const raw = sessionStorage.getItem('accessPermissions');
  return raw ? JSON.parse(raw) : null;
}

function buildPermissionMap(permissions: IAccessProfileMenu[]) {
  const map = new Map<string, boolean>();

  permissions.forEach(p => {
    map.set(p.name, p.actionView ?? true);
  });

  return map;
}

function mapMenuItem(item: AccessMenuItem, permissionMap: Map<string, boolean>) {
  const hasPermission = permissionMap.get(item.name);

  const subItems = filterSubItems(item, permissionMap);

  if (!hasPermission && subItems.length === 0) {
    return null;
  }

  return {
    ...item,
    route: resolveRoute(item, subItems),
    subItems
  };
}

function filterSubItems(item: AccessMenuItem, permissionMap: Map<string, boolean>) {
  if (!item.subItems?.length) return [];

  return item.subItems.filter(
    (sub) =>
      sub.name !== item.parentPermission &&
      permissionMap.get(sub.name)
  );
}

function resolveRoute(item: AccessMenuItem, subItems: AccessMenuItem[]) {
  const hasParentPermissionSub = item.parentPermission &&
    item.subItems?.some(
      (sub) => sub.name === item.parentPermission
    );

  if (subItems.length > 0 && !hasParentPermissionSub) {
    return subItems[0].route;
  }

  return item.route;
}
